<template>
  <TemplateHeader
    :header="'Riwayat Penjualan'"
    :withBackButton="true"
    :to="`/dashboard/${id}`"
    :branch_name="branch_name"
  >
    <TableSold :API="`/sold-product/${id}`" :allData="true" />
  </TemplateHeader>
</template>

<script>
import TemplateHeader from "../../../layouts/TemplateHeader.vue";
import TableSold from "../../../components/Table/TableSold.vue";

import dataService from "../../../services/data.service";

export default {
  components: {
    TemplateHeader,
    TableSold,
  },
  data() {
    return {
      dataCabang: [],
      branch_name: "",
      id: this.$route.params.id,
    };
  },
  methods: {
    async getCabang() {
      this.cabangLoading = true;
      const id = this.$route.params.id;

      await dataService.getCabang().then((res) => {
        this.dataCabang = res.data;

        const findCabang = this.dataCabang.find((data) => data.id == id);

        this.branch_name = findCabang.branch_name;
        this.cabangLoading = false;
      });
    },
  },
  created() {
    this.getCabang();
  },
};
</script>
